module.exports = __webpack_public_path__ + "img/杨建华.55cd9964.jpg";